import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useContractInventoryFormState } from 'shared/contexts/contract-inventory-form-context';
import { useUpdateContract } from 'shared/mutations';
import { useGetContract } from 'shared/queries';
import { ContractDocument } from 'shared/types';

export function ContractStatusDialog() {
  const updateContractMutation = useUpdateContract();
  const { enqueueSnackbar } = useSnackbar();
  const {
    state,
    contractStatusDialogOpen,
    toggleContractStatusDialog,
    setContractIdForToggleStatus,
  } = useContractInventoryFormState();
  const contractId = state.contractIdForTogglingStatus;
  const { contract } = useGetContract(contractId);

  const onClose = useCallback(() => {
    setContractIdForToggleStatus('');
    toggleContractStatusDialog();
  }, [setContractIdForToggleStatus, toggleContractStatusDialog]);

  const onToggleContractStatus = useCallback(async () => {
    let updatedContract: ContractDocument = {
      ...contract!,
      status: contract?.status === 'active' ? 'inactive' : 'active',
    };

    if (contract) {
      await updateContractMutation.mutateAsync(updatedContract);
    } else {
      enqueueSnackbar('Contract was not updated', { variant: 'error' });
    }
    setContractIdForToggleStatus('');
    toggleContractStatusDialog();
  }, [contract, setContractIdForToggleStatus, toggleContractStatusDialog, updateContractMutation, enqueueSnackbar]);

  return (
    <Dialog open={contractStatusDialogOpen} onClose={onClose} fullWidth={true} aria-labelledby='contract-status-dialog'>
      <DialogTitle id='contract-status-title'>{`Are you sure you want to ${
        contract?.status === 'inactive' ? 'activate' : 'deactivate'
      } this contract?`}</DialogTitle>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          No
        </Button>
        <Button onClick={onToggleContractStatus} color='primary'>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
